import { Button, Form, Modal, Radio, Select, Switch, message } from "antd";
import { Option } from "antd/lib/mentions";
import React, { useEffect, useRef, useState } from "react";
import {
  export2DProjectOnFloorPlanner,
  exportProjectOnFloorPlanner,
} from "../../../../apis/floorPlannerApis";
import ImportConfirmationDialog from "./ImportConfirmationDialog";
import "./params2dForm.scss";

const Params2dForm = (props) => {
  const [includeFML, setIncludeFML] = useState(false);
  const [form] = Form.useForm();
  const [confirmForm] = Form.useForm();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const toast = useRef(null);

  const getFilteredFloorValues = () => {
    return props.floorOptions.filter(floor => 
      !floor.label.toLowerCase().includes('nen') && 
      !floor.label.toLowerCase().includes('perceelt')
    ).map(floor => floor.value);
  };

  useEffect(() => {
    form.setFieldsValue(
      { floors: props.selectedFloors }
    )
    confirmForm.setFieldsValue(
      { backgroundFloors: getFilteredFloorValues(),
        nenOrientation: "landscape"
      }
    )
  }, [props.selectedFloors, props.floorOptions])

  const onFinish = (values) => {
    export2DProjectOnFloorPlanner(
      props.floorPlannerProjectId,
      props.projectId,
      values
    ).then((response) => {
      if (response.status === 200) {
        props.projectImport();
        message.success("Project imported successfully");
      }
    });
    props.visible(false);
  };

  const exportProjectonnFloorPlanner = (values) => {
    exportProjectOnFloorPlanner(
      props.floorPlannerProjectId,
      props.projectId,
      { floors: values.floors,
        visual: values.visual,
        backgroundFloors: values.backgroundFloors,
        nenOrientation: values.nenOrientation
       }
    ).then((response) => {
      if (response.status === 200) {
        props.projectImport();
        message.success("Project imported successfully");
      }
    });
    props.visible(false);
    message.info("Project import is processing!");
  };

  const layout = {
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  };

  const validateMessages = {
    required: "${label} is required!",
  };

  const onSwitchChange = (checked) => {
    setIncludeFML(checked);
  };

  return (
    <React.Fragment>
      <Form form={form}
        {...layout}
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={validateMessages}
      >
        <div className="style-change">
          <Form.Item
            className="orientation-label"
            name="orientation"
            label="Orientation"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Radio.Group className="radio-btns">
              <Radio.Button value="landscape">Landscape</Radio.Button>
              <Radio.Button value="portrait">Portrait</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </div>
        <Form.Item label="Include FML" name="includeFML">
          <Switch className="radio-btns" onChange={onSwitchChange} />
        </Form.Item>
        <Form.Item
          label="Color mode"
          name="visual"
        >
          <Select
            onChange={(e) => {
            }}
            style={{ width: 175 }}
            placeholder="Select"
            defaultValue={"BWC"}
            dropdownStyle={{ zIndex: 10000 }}>
            <Option value="BW">Black and white</Option>
            <Option value="BWC">Color</Option>
            <Option value="ALL">Material</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Floors" name="floors">
          <Select
            mode="multiple"
            onChange={(e) => {
            }}
            options={props.floorOptions}
            style={{ width: 175 }}
            placeholder="Select"
            dropdownStyle={{ zIndex: 10000 }}>
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            style={{
              width: "80%",
              marginLeft: "28%",
            }}
            type="primary"
            onClick={(e) => {
              form.validateFields().then(() => {
                onFinish(form.getFieldsValue());
              }).catch(errorInfo => {
                toast.current.show({
                  severity: "info",
                  summary: "Status",
                  detail: errorInfo,
                  life: 5000,
                });
              });
            }
            }
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
      <div>
        {/* {props.containsNEN && (
          <p style={{ color: "red", fontSize: 11, marginLeft: 70, marginBottom: 10 }}>
            Project contains NEN floor. It will be removed when importing the total project.
          </p>
        )} */}
      </div>
      <Button
        type="primary"
        style={{
          width: "57%",
          marginLeft: "20%",
        }}
        onClick={(e) => {
          setShowConfirmDialog(true);
        }}
      >
        Import total project
      </Button>
      <ImportConfirmationDialog
        open={showConfirmDialog}
        onCancel={() => setShowConfirmDialog(false)}
        onConfirm={(values) => {
          setShowConfirmDialog(false);
          exportProjectonnFloorPlanner(values);
        }}
        confirmForm={confirmForm}
        floorOptions={props.floorOptions}
      />
    </React.Fragment>
  );
};

export default Params2dForm;
